// Hero slider — auto-init every `.hero-slider` on the page using Swiper.
//
// Swiper itself (the global `Swiper` constructor) is loaded from CDN by the
// template's index.php via the Joomla web asset manager, so it's available
// site-wide. This module runs on DOMContentLoaded, finds every matching
// element, and binds a Swiper instance with sensible defaults.
//
// Per-instance overrides via `data-*` on the `.hero-slider` element:
//   data-effect="slide|fade"     default: fade
//   data-loop="true|false"       default: true
//   data-autoplay="false"        disables autoplay
//   data-autoplay="3000"         autoplay delay in ms (default 5000)
//   data-speed="700"             transition speed in ms (default 700)
//
// Pagination + nav controls are auto-wired when the corresponding
// `.swiper-pagination`, `.swiper-button-prev`, `.swiper-button-next`
// elements exist inside the slider.

function initSlider(el) {
  if (el.dataset.sliderInited === '1' || typeof window.Swiper === 'undefined') {
    return;
  }

  const data = el.dataset;
  const config = {
    loop: data.loop !== 'false',
    speed: parseInt(data.speed, 10) || 700,
    effect: data.effect || 'fade',
    fadeEffect: { crossFade: true },
    keyboard: { enabled: true },
    grabCursor: true,
    a11y: {
      prevSlideMessage: 'Prethodno',
      nextSlideMessage: 'Sljedeće',
      paginationBulletMessage: 'Idi na slajd {{index}}'
    }
  };

  if (data.autoplay !== 'false') {
    const delay = parseInt(data.autoplay, 10);
    config.autoplay = {
      delay: Number.isFinite(delay) && delay > 0 ? delay : 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
  }

  if (el.querySelector('.swiper-pagination')) {
    config.pagination = {
      el: el.querySelector('.swiper-pagination'),
      clickable: true
    };
  }

  if (el.querySelector('.swiper-button-next')) {
    config.navigation = {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev')
    };
  }

  el.dataset.sliderInited = '1';
  // eslint-disable-next-line no-new
  new window.Swiper(el, config);
}

function initAll() {
  // Swiper itself is loaded by a separate <script defer> tag that may not
  // have executed yet when this module runs. If it isn't ready yet, retry
  // once after `window.load` — by then every deferred script has run.
  if (typeof window.Swiper === 'undefined') {
    window.addEventListener('load', initAll, { once: true });
    return;
  }
  document.querySelectorAll('.hero-slider').forEach(initSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
